export default __webpack_public_path__ + "static/media/instagram.ac32ec0a.png";